import { useQuery } from '@tanstack/react-query';
import {
  type CalculatePaymentPlanFilter,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import dayjs from 'dayjs';
import { feeKeys } from './keys';

const paymentPlanInstallments = graphql(/* GraphQL */ `
  query fees_paymentPlanInstallments($filter: CalculatePaymentPlanFilter) {
    fees_paymentPlanInstallments(filter: $filter) {
      id {
        feeId
        studentPartyId
      }
      installments {
        installment
        installmentDate
        amount
        serviceCharges
        absorbFees
      }
    }
  }
`);

const paymentPlanInstallmentsQuery = (filter: CalculatePaymentPlanFilter) => ({
  queryKey: feeKeys.paymentPlanInstallments(filter),
  queryFn: async () => {
    const { fees_paymentPlanInstallments: paymentPlanInstallmentsData } =
      await gqlClient.request(paymentPlanInstallments, { filter });

    return paymentPlanInstallmentsData.map((item) => ({
      ...item,
      installments: item?.installments.sort(
        (a, b) =>
          dayjs(a.installmentDate).unix() - dayjs(b.installmentDate).unix(),
      ),
    }));
  },
});

export function getPaymentPlanInstallments(filter: CalculatePaymentPlanFilter) {
  return queryClient.fetchQuery(paymentPlanInstallmentsQuery(filter));
}

export function usePaymentPlanInstallments(filter: CalculatePaymentPlanFilter) {
  return useQuery({
    ...paymentPlanInstallmentsQuery(filter),
    select: (paymentPlanInstallmentsData) => paymentPlanInstallmentsData,
  });
}

export type ReturnTypeFromUsePaymentPlanInstallments = UseQueryReturnType<
  typeof usePaymentPlanInstallments
>;
